import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom/client';

import ff from '@prosperllc/web-feature-flags';
import { PostHogProvider } from '@utilities/posthog';

import App from './App';

// Async function used b/c need env-specific resources to load before React
const loadFeatureFlags = async () => {
  // have to ts ignore because the typecsript interface isn't set up correctly in web-ff
  await ff.loadFeatureFlags();
  // Set cookie expiration
  // @ts-expect-error below
  if (window.optimizely) {
    // @ts-expect-error below
    window.optimizely.push({
      type: 'cookieExpiration',
      cookieExpirationDays: 90,
    });
  }
};

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement as HTMLElement);
const renderApp = () => {
  root.render(
    <React.StrictMode>
      <PostHogProvider>
        <App />
      </PostHogProvider>
    </React.StrictMode>
  );
};

loadFeatureFlags().then(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
